<template>
  <g-page-wrapper>
    <template slot="pageTitle">
      <g-page-title :title="$t('pages_servicerequest_list.path')"
        id="service-request-list-g-page-title"
      ></g-page-title>
    </template>
    <g-contents>
      <div class="-p-5">
        <div class="dashboard-layout -mb-5">
          <service-request-total-trend
            @onClickTrend="onClickTrend"
            id="service-request-list-total-trend-component"
          />
          <service-request-top-five-trend
          id="service-request-list-top-five-trend-component"
            @onClickTrend="onClickTrend"
          />
        </div>
        <div class="-tile-container " id="service">

          <div class="-wrapper">
            <div @click.capture="onDatePickerClick">
              <date-picker
                id="service-request-list-datepicker"
                v-model="serviceRequestSearchDate"
                :clearable="false"
                :editable="false"
                style="width: 200px;"
                :range="true"
                @change="onSearchDateChange"
                value-type="format" format="YYYY-MM-DD"
                :disabled-date="notAfterToday"
                input-class='-btn secondary- start- large- mx-input-calendar -mx-input-calendar-range'
                :lang="locale.toLowerCase()"
                :open.sync="open"
                @open="onOpen"
                >
              </date-picker>
            </div>

            <div class="-wrapper-stretch h-v-center- -pl-1" style="max-width: 200px;min-width: 30px;margin-left:10px">
              <g-dropdown
                id="service-request-list-dropdown-01"
                dropdown-type="button"
                variant="secondary"
                style="width: 180px"
                v-model="statusKey"
                >
                <g-dropdown-item-wrap>
                  <g-dropdown-item
                    v-for="status in serviceRequestStatus"
                    :key="status.value"
                    :text="$t('pages_servicerequest.division.'+ status.value) "
                    :value="status.value"
                  />
                </g-dropdown-item-wrap>
              </g-dropdown>
            </div>
          </div>
          <div class="-tile-container ">
            <div class="-wrapper -mt-3 -mb-3"
              id="service-request-list-division"
            >
              <p class="-font-size-12"> {{ $t('pages_servicerequest.division.total') }}
                <span class="-badge " style="color: black">
                  {{!!serviceRequestStatus && serviceRequestStatus.length > 0? serviceRequestStatus[0].count : 0}}
                </span>
              </p>

              <p class="-font-size-12 -ml-3" v-for="status in serviceRequestStatus" :key="status.value" v-show="status.value != 'all'" >
              {{ $t(`pages_servicerequest.division.${status.value}`) }}
                <span :class="`-badge ${status.style} -ml-1`">{{status.count || 0}}</span>
              </p>

            </div>
          </div>
          <div class="-wrapper -bg-white" >
            <g-search-bar
              id="service-request-list-search-bar-01"
              style="width: 98%;"
              no-border
              placeholder="Search anything"
              v-model="searchText" />
            <g-button
              id="service-request-list-search-bar-button-01"
              variant="borderless"
              size="small"
              icon-only
              class="-mt-2 -minus-ml-2"
              @click="onClickDownload">
              <g-icon name="get_app"  width="16px" height="16px" color="gray-1" />
            </g-button>
          </div>
          <ag-grid-vue
            id="service-request-list-ag-grid-vue"
            style="height: 300px;"
            class="ag-theme-balham"
            row-height="30"
            header-height="30"
            :defaultColDef="defaultColDef"
            :columnDefs="columnDefs"
            :gridOptions="gridOptions"
            :rowData="serviceRequestListData"
            :overlayLoadingTemplate="overlayLoadingTemplate"
            :loadingOverlayComponent="loadingOverlayComponent"
            :loadingOverlayComponentParams="loadingOverlayComponentParams"
            :overlayNoRowsTemplate="overlayNoRowsTemplate"
            :noRowsOverlayComponent="noRowsOverlayComponent"
            :noRowsOverlayComponentParams="noRowsOverlayComponentParams"
            :frameworkComponents="frameworkComponents"
            :modules="modules"
            :paginationPageSize="paging.size"
            :pagination="true"
            :suppressPaginationPanel="true"
            :suppressScrollOnNewData="true"
            @pagination-changed="paginationChanged"
            @row-clicked="selectServiceRequestInfo"
            @grid-ready="onGridReady"
            @row-data-changed="onRowDataChanged">
          </ag-grid-vue>
          <g-pagenation
            id="service-request-list-g-pagenation"
            class="-py-6"
            :page-no="paging.pageNo"
            :page-size-list="pageSizeList"
            :page-size="paging.size"
            :total-count="paging.totalCount"
            @change-page-no="onChangePageNo"
            @change-page-size="onChangePageSize"/>
        </div>


      </div>
    </g-contents>
  </g-page-wrapper>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import { mapActions, mapGetters } from 'vuex';
import AgGridMixin from "@/pages/mixin/AgGrid.mixin";
import {DEFAULT_OPTION_PER_PAGE, DEFAULT_PAGE_SIZE} from "@/constants/constants"
import ServiceRequestTotalTrend from "./components/ServiceRequestTotalTrend"
import ServiceRequestTopFiveTrend from "./components/ServiceRequestTopFiveTrend"
import DatePicker from 'vue2-datepicker'
import moment from 'moment';
import 'vue2-datepicker/locale/ko';
import 'vue2-datepicker/locale/en';
import 'vue2-datepicker/locale/zh-cn';
import 'vue2-datepicker/locale/ja';
var that;

  export default {
    name: 'servicerequest-list',
    componentName: 'ServiceRequestList',
    components: {AgGridVue, ServiceRequestTotalTrend, ServiceRequestTopFiveTrend, DatePicker},
    mixins: [AgGridMixin()],
    data () {
      return {
        open: false,
        datePickerOpen:  false,
        searchText: '',
        serviceRequestListData: [],
        pageSizeList: DEFAULT_OPTION_PER_PAGE,
        columnDefs: [],
        paging : {
          pageNo : 1,
          size : DEFAULT_PAGE_SIZE,
          startIndex : 0,
          totalCount : 0
        },
        category: 'customerName',
        orderCol: '',
        desc: false,
        paths: [{
          path: '/servicereqeusts',
          name: this.$t('pages_product_ProductList.1')
        }],
        serviceRequestSearchDate: [moment(new Date().getTime()).add(-6, 'd').format('YYYY-MM-DD') , moment(new Date()).format('YYYY-MM-DD')],
        statusKey: '',
        serviceRequestStatus: []
      }
    },
    computed: {
      ...mapGetters('servicerequest', ['serviceRequestList', 'serviceRequestStatusCombo']),
      ...mapGetters('locale', ['locale'])
    },
    methods: {
      ...mapActions('servicerequest', ['getServiceRequestList', 'getServiceRequestStatusCombo']),
      onStatucSelected(){

      },
      onOpen(){
        this.datePickerOpen = true;
      },
      onDatePickerClick(){
        if(!this.datePickerOpen){
          this.open = false;
        }else{
          this.datePickerOpen = false;
        }
      },
      onClickTrend(date, filters){
        this.serviceRequestSearchDate = [date, date];
        this.changeServiceRequests(filters);
      },
      notAfterToday(date) {
        return date > new Date(new Date().setHours(0, 0, 0, 0))
          || date < new Date(new Date().getTime() - 30 * 24 * 3600 * 1000);
      },
      onSearchDateChange(value){
        this.serviceRequestList = value;
        this.changeServiceRequests();
      },
      onGridReady (params) {
        this.getServiceRequestStatusCombo().then(function(serviceRequestStatusCombo){
          that.serviceRequestStatus = JSON.parse(JSON.stringify(serviceRequestStatusCombo));
          that.setGridParams(params);
          that.fitGrid();

          const date = that.$route.query.date
          if (date) {
            that.serviceRequestSearchDate = [date, date]
          }


          that.changeServiceRequests();
          that.rowData = that.serviceRequestList;
          that.paging.totalCount = that.serviceRequestList.length
        });
      },
      onChangePageNo (pageNo) {
        this.paging.pageNo = pageNo;
        this.gridApi.paginationGoToPage(pageNo - 1);
      },
      onChangePageSize (pageSize) {
        this.paging.size = pageSize;
        this.paging.pageNo = 1;
        this.fitGrid()
        this.gridApi.paginationSetPageSize(this.paging.size);
        this.gridApi.paginationGoToPage(this.paging.pageNo - 1);

      },
      onSearch() {

      },
      selectServiceRequestInfo(event) {
        this.$router.push(`/servicerequest/info?id=${event.data.id}`)
      },
      changeServiceRequests (filters) {

        let payLoad = {
          empNo: '',
          startDate: this.serviceRequestSearchDate[0],
          endDate: this.serviceRequestSearchDate[1],
          customerDepts: [],
          filters: filters
        }
        this.gridApi.showLoadingOverlay()

        const that = this;
        that.serviceRequestListData = []
        that.statusKey = 'all'
        this.getServiceRequestList(payLoad).then(function(){
          that.serviceRequestStatus.forEach(status => {
            status.count = 0
          });
          that.serviceRequestList.forEach(item => {
            that.serviceRequestStatus[0].count = that.serviceRequestStatus[0].count + 1
            let matchedStatus =  that.serviceRequestStatus.find(status => status.value == item.division)
            matchedStatus.count =  matchedStatus.count + 1
          })
          that.serviceRequestListData = that.serviceRequestList
        });
      },
      onRowDataChanged (e) {
        if (!!this.serviceRequestList && this.serviceRequestList.length > 0) {
          this.gridApi.hideOverlay()
        } else {
          this.gridApi.showNoRowsOverlay()
        }
        this.fitGrid()
      },
      paginationChanged (e) { // totalcount 업데이트
        this.paging.totalCount = e.api.rowModel.rowsToDisplay.length
      },
      rowClicked () {},
      onClickDownload () {
        let params = {
          fileName: 'servicerequest_list',
          allColumns: false,
          onlySelected: false,
          columnKeys: ['customerName', 'requesterName', 'receiveDate', 'updateDate', 'subject', 'division'],
          processCellCallback: (params)=>{
            if(params.column.colId == 'division'){
              return this.$t('pages_servicerequest.division.' + params.value)
            }else{
              return params.value
            }
          }
        }
        this.gridApi.exportDataAsCsv(params);
      },
      setColumn () {
        this.columnDefs = [
          {
            headerName: this.$t('pages_servicerequest.list.column.header.number'),
            field: "no",
            minWidth: 80,
            maxWidth: 120,
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"},
            resizable: false
          },
          {
            headerName: this.$t('pages_servicerequest.list.column.header.customerName'),
            field: "customerName",
            minWidth: 120,
            maxWidth: 200,
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          },
          {
            headerName: this.$t('pages_servicerequest.list.column.header.requester'),
            field: "requesterName",
            minWidth: 80,
            maxWidth: 120,
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          },
          {
            headerName: this.$t('pages_servicerequest.list.column.header.receiveDate'),
            field: "receiveDate",
            minWidth: 100,
            maxWidth: 150,
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          },
          {
            headerName: this.$t('pages_servicerequest.list.column.header.updateDate'),
            field: "updateDate",
            minWidth: 100,
            maxWidth: 150,
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          },
          {
            headerName: this.$t('pages_servicerequest.list.column.header.subject'),
            field: "subject",
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          },
          {
            headerName: this.$t('pages_servicerequest.list.column.header.status'),
            field: "division",
            minWidth: 80,
            maxWidth: 120,
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"},
            cellRenderer : parameter => {
              let data = parameter.data
              //data.division
              return '<p class="'+ that.serviceRequestStatus.find(s => s.value == data.division).cellStyle +'">'+this.$t('pages_servicerequest.division.'+ data.division)+'</p>'
            },
            comparator: function(a, b){
              return that.$t('pages_servicerequest.division.'+ a).localeCompare(that.$t('pages_servicerequest.division.'+ b))
            },
            getQuickFilterText: params => {
                return that.$t('pages_servicerequest.division.'+ params.value);
            }
          }
        ]
      }
    },
    watch: {
      searchText () {
        this.gridOptions.api.setQuickFilter(this.searchText)
      },
      serviceRequestList () {
        if (!!this.serviceRequestList && this.serviceRequestList.length > 0) {
          this.gridApi.hideOverlay()
        } else {
          this.gridApi.showNoRowsOverlay()
        }
      },
      serviceRequestListData() {
        this.fitGrid()
      },
      statusKey () {
        if(this.statusKey === 'all'){
          this.serviceRequestListData = this.serviceRequestList;
        }else{
          this.serviceRequestListData = this.serviceRequestList.filter(sr=> {
            return sr.division === this.statusKey
          })
        }
      }
    },
    beforeMount () {
      that = this;
    }
  }

</script>
<style >
.-mx-input-calendar-range {
  width: 200px !important
}

</style>



// WEBPACK FOOTER //
// src/pages/servicerequest/ServiceRequestList.vue